export const API_URL = process.env.API_URL;
export const TIMEOUT_SECONDS = 150;
